<template>
	<JBox class="s-bg-white s-border-gray-300 s-border s-px-4 s-pb-4 s-rounded-lg">
		<!-- Output Fields -->
		<JHeadline class="s-text-gray-900 s-text-md s-font-medium s-mt-4">{{ $t("templates.outputFields") }}</JHeadline>
		<JBox v-if="!outputs">
			{{ $t("templates.noFunctionTemplateData") }}
		</JBox>
		<JBox v-else>
			<div v-for="(item, index) in outputs" :key="index" class="s-mt-4">
				<p class="s-mb-1">{{ item.var }}</p>
				<JFlex class="s-justify-between s-items-center">
					<div
						@click="handleSelect(item, index)"
						class="s-cursor-pointer s-w-full s-p-2 s-border s-rounded s-border-gray-300"
						:class="item.isNotExist ? 's-border-red-500' : item.isNotAdded ? 's-border-yellow-300' : 's-border-gray-300'"
					>
						<span>{{ item.liquid || "---" }}</span>
					</div>

					<div v-if="item.isNotExist" class="s-ml-2 s-cursor-pointer" @click="removeOutput(item.id)">
						x
					</div>
				</JFlex>
				<div v-if="item.isNotAdded" class="s-text-sm s-font-medium s-mt-1 s-text-yellow-300">
					{{ $t("templates.outputNotAdded") }}
				</div>
				<div v-if="item.isNotExist" class="s-text-sm s-font-medium s-mt-1 s-text-red-500">
					{{ $t("templates.outputNotExist") }}
				</div>
			</div>
		</JBox>
	</JBox>
</template>

<script>
import api from "@/api/api"
import { mutation } from "../../api/queries"

export default {
	props: {
		id: {
			type: String
		},
		templateOutputs: {
			type: Array
		},
		excelOutputs: {
			type: Array
		},
		outputPrefix: {
			type: String
		}
	},

	data() {
		return {
			outputs: []
		}
	},

	methods: {
		compareOutputs(excelOutputs, templateOutputs) {
			const array1 = excelOutputs?.map(item => item.label)
			const array2 = templateOutputs?.map(item => item.var)
			const itemsNotAdded = array1?.filter(item => !array2?.includes(item))
			const itemsNotExist = array2?.filter(item => !array1?.includes(item))
			return { itemsNotAdded, itemsNotExist }
		},
		decideOutputs({ itemsNotExist, itemsNotAdded }) {
			let output = []
			// outputs NOT existing on Excel but added on Template will be highlighted with a red border
			output = this.outputs?.map(item => {
				if (itemsNotExist?.includes(item.var)) {
					return { ...item, isNotExist: true }
				} else return item
			})
			if (this?.outputs?.length > 0) {
				// outputs existing on Excel but not added on Template will be highlighted with a yellow border
				output.push(
					...itemsNotAdded?.map(item => ({
						var: item,
						liquid: null,
						isNotAdded: true
					}))
				)
			} else {
				output = [
					...itemsNotAdded?.map(item => ({
						var: item,
						liquid: null,
						isNotAdded: true
					}))
				]
			}
			return output
		},
		handleSelect(item, index) {
			if (!item?.isNotAdded) return
			const foundInput = this.outputs[index]
			this.addTemplateOutput(foundInput, index)
		},
		async addTemplateOutput(payload, index) {
			const input = {
				name: payload?.var?.replace(this.outputPrefix, ""),
				var: payload?.var
			}
			const variables = {
				id: this.id,
				input
			}
			const res = await api({ query: mutation.addOutputToFunctionTemplate, variables })
			if (res?.data?.addOutputToFunctionTemplate?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.addOutputToFunctionTemplate?.errors?.[0] }
				})
			} else {
				// manually changing local state so that we dont have to refetch template
				this.outputs[index] = {
					id: res?.data?.addOutputToFunctionTemplate?.createdStatus?.id,
					...input
				}
			}
			const { itemsNotAdded, itemsNotExist } = this.compareOutputs(this.excelOutputs, this.outputs)
			this.outputs = this.decideOutputs({ itemsNotAdded, itemsNotExist })
		},
		async removeOutput(id) {
			const variables = {
				templateId: this.id,
				outputId: id
			}
			const res = await api({ query: mutation.removeOutputFromFunctionTemplate, variables })
			if (res?.data?.removeOutputFromFunctionTemplate?.status !== "success") {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.errors?.[0] || res?.data?.removeOutputFromFunctionTemplate?.errors?.[0] }
				})
			} else {
				this.outputs = this.outputs?.filter(item => item.id !== id)
			}
		}
	},

	watch: {
		templateOutputs: {
			handler() {
				this.outputs = this.templateOutputs
			},
			immediate: true,
			deep: true
		},
		excelOutputs: {
			handler() {
				const { itemsNotAdded, itemsNotExist } = this.compareOutputs(this.excelOutputs, this.templateOutputs)
				this.outputs = this.decideOutputs({ itemsNotAdded, itemsNotExist })
			},
			immediate: true
		}
	}
}
</script>
